import { useInfiniteQuery } from 'react-query'

import '@hapana/shared/utils/type-defs.util'
import { useErrorHandler } from '@hapana/shared/web/hooks/errors.hooks'
import { GENERIC_ERROR_KEY } from '@hapana/shared/constants/errors.constants'
import { getClients } from '@services/check-in/clients.service'
import useSiteStore from '_stores/site.store'

/** @type {function():InfiniteQueryResult} */

export const useClients = ({ search, paginate }) => {
  const { onError } = useErrorHandler(GENERIC_ERROR_KEY)
  const { currentSite } = useSiteStore()
  const siteId = currentSite?.siteId

  return useInfiniteQuery(
    [getClients.key, { search, cursor: paginate?.cursor, pageSize: paginate?.pageSize, siteId }],
    getClients.query,
    {
      getNextPageParam: (lastPage) => {
        if (lastPage?.clients?.pageInfo?.hasNextPage) {
          return {
            cursor: lastPage.clients.pageInfo.endCursor,
            pageSize: paginate?.pageSize,
          }
        }
        return undefined
      },
      enabled: !!search,
      onError,
    }
  )
}
